import React from 'react';
import PropTypes from 'prop-types';
import { Box, Icons, useTheme } from '@ublend-npm/aulaui-core';
import { InputBase } from '@mui/material';

interface SpacesSearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

const SpacesSearchInput: React.FC<SpacesSearchInputProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();
  return (
    <InputBase
      id="space-search-input"
      inputProps={{
        'aria-label': 'Search spaces by name',
        role: 'searchbox',
        style: { height: 48 },
      }}
      placeholder="Search spaces by name"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      startAdornment={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            m: '12px 8px 12px 11px',
          }}
        >
          <Icons.Search
            aria-hidden="true"
            sx={{ height: '24px', width: '24px' }}
          />
        </Box>
      }
      tabIndex={0}
      sx={{
        height: 48,
        width: '100%',
        maxWidth: { xs: '100%', sm: theme.spacing(45) },
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: 1,
        paddingRight: theme.spacing(1.5),
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        fontSize: theme.typography.fontSize,
        backgroundColor: theme.palette.background.paper,

        '&:hover': {
          borderColor: theme.palette.text.primary,
        },
        '&:focus-within': {
          borderColor: theme.palette.primary.main,
        },

        '& input': {
          padding: 0,
          height: 48,
          fontSize: '1rem',
          lineHeight: '24px',
          color: theme.palette.text.primary,
        },
      }}
    />
  );
};

SpacesSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SpacesSearchInput;
